/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/**
 * --------------------------------------------------------------------------------------------------------------------
 * GIFT CARD RECIPIENT ("I want to send this as a gift")
 *
 * Drives the markup rendered by snippets/gift-card-recipient-form.liquid.
 *
 * Everything is delegated from the document rather than initialised per instance, so it keeps working for markup that
 * appears after this file has run: sections re-rendered by the theme editor, or a second product form on the page.
 *
 * The recipient fields ship from Liquid already `disabled`, so this file only ever has to turn them on. If it fails to
 * load, the checkbox does nothing and the add-to-cart payload is unchanged.
 * --------------------------------------------------------------------------------------------------------------------
 */
(function () {
  var CHECKBOX_SELECTOR = '[data-gift-card-recipient-checkbox]',
      FIELDS_SELECTOR = '[data-gift-card-recipient-fields]',
      ADD_TO_CART_SELECTOR = '.ProductForm__AddToCart',
      ACTIVE_FORM_CLASS = 'ProductForm--giftCardRecipientActive';

  /**
   * Element.closest is missing in older browsers, and the theme still targets them
   */
  function closest(element, selector) {
    while (element && element.nodeType === 1) {
      var matches = element.matches || element.msMatchesSelector || element.webkitMatchesSelector;

      if (matches && matches.call(element, selector)) {
        return element;
      }

      element = element.parentElement;
    }

    return null;
  }

  function getContext(checkbox) {
    var root = closest(checkbox, '.GiftCardRecipient');

    if (!root) {
      return null;
    }

    var fields = root.querySelector(FIELDS_SELECTOR);

    return fields ? { root: root, fields: fields, form: closest(root, 'form') } : null;
  }

  /**
   * Today in the shopper's own timezone, as YYYY-MM-DD
   */
  function localToday() {
    var now = new Date();

    now.setMinutes(now.getMinutes() - now.getTimezoneOffset());

    return now.toISOString().split('T')[0];
  }

  function sync(checkbox) {
    var context = getContext(checkbox);

    if (!context) {
      return;
    }

    var isActive = checkbox.checked,
        inputs = context.fields.querySelectorAll('input, textarea, select'),
        i;

    context.fields.hidden = !isActive;
    checkbox.setAttribute('aria-expanded', isActive ? 'true' : 'false');

    // Disabled controls are skipped by the theme form serializer, so nothing extra
    // reaches /cart/add while the option is switched off
    for (i = 0; i < inputs.length; i++) {
      inputs[i].disabled = !isActive;
    }

    if (isActive) {
      var offsetInput = context.fields.querySelector('[data-gift-card-recipient-offset]'),
          sendOnInput = context.fields.querySelector('[data-gift-card-recipient-send-on]');

      if (offsetInput) {
        offsetInput.value = new Date().getTimezoneOffset();
      }

      // A gift card cannot be scheduled for a date that has already passed
      if (sendOnInput) {
        sendOnInput.setAttribute('min', localToday());
      }
    }

    // The dynamic checkout button skips the cart, where the recipient details are
    // reviewed. A class is used rather than an inline style so the theme keeps full
    // control of that button's own show/hide logic on variant changes.
    if (context.form) {
      if (isActive) {
        context.form.classList.add(ACTIVE_FORM_CLASS);
      } else {
        context.form.classList.remove(ACTIVE_FORM_CLASS);
      }
    }
  }

  /**
   * The checkbox ships disabled from Liquid so that a no-JS shopper cannot submit the control flag without the
   * recipient fields. Turning it on is the only thing that needs an init pass rather than delegation.
   */
  function enableCheckboxes(scope) {
    var checkboxes = (scope || document).querySelectorAll(CHECKBOX_SELECTOR),
        i;

    for (i = 0; i < checkboxes.length; i++) {
      checkboxes[i].disabled = false;
    }
  }

  document.addEventListener('change', function (event) {
    var checkbox = closest(event.target, CHECKBOX_SELECTOR);

    if (checkbox) {
      sync(checkbox);
    }
  });

  /**
   * The theme adds to cart from a delegated click handler that calls preventDefault(), so the browser never runs its
   * own constraint validation. Listening on the document in the capture phase guarantees this runs first.
   */
  document.addEventListener('click', function (event) {
    var button = closest(event.target, ADD_TO_CART_SELECTOR);

    if (!button) {
      return;
    }

    var form = closest(button, 'form');

    if (!form) {
      return;
    }

    var checkbox = form.querySelector(CHECKBOX_SELECTOR);

    if (!checkbox || !checkbox.checked) {
      return;
    }

    var fields = form.querySelector(FIELDS_SELECTOR),
        invalidField = fields && fields.querySelector(':invalid');

    if (!invalidField) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();
    invalidField.focus();

    if (typeof invalidField.reportValidity === 'function') {
      invalidField.reportValidity();
    }
  }, true);

  // Sections re-rendered by the theme editor come back with the checkbox disabled again
  document.addEventListener('shopify:section:load', function (event) {
    enableCheckboxes(event.target);
  });

  // This file is deferred, so the document has already been parsed by the time it runs
  enableCheckboxes();
})();